<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <article class="content content--2" v-html="body" />
</template>

<script>
export default {
  name: 'BasicView',
  props:{
    body: {
      type: String,
      default: () => '<h1>Basic View</h1><p>Default content</p>',
    },
  },
  mounted() {
    this.$el.querySelectorAll('a').forEach(a => {
      if(a.href.includes('awards/')) {
        a.addEventListener(('click'), e => {
          e.preventDefault();
          const url = new URL(a.href)
          const routerLocation = url.pathname.replace("/awards", "")
          this.$router.push(routerLocation);
        })
      }
    })

  },
}
</script>

<style lang="css" scoped>
.content {
  margin-top: 4rem;
  margin-bottom: 4rem;
}
>>> strong {
  font-weight: normal;
  color: #B3258C; /* $dark-magenta */
}
article {
  min-height: 0;
}
</style>
